import { useEffect } from 'react';

import { useRequestGateway } from '@app-velocity/request-gateway';

import { TAuthenticationDto } from '@app-velocity/av-api-v2';

import { useAuthenticateMutation } from '../queries/useAuthenticateMutation';

const checkUserData = (
  data?: TAuthenticationDto
): data is Required<TAuthenticationDto> => {
  if (!data) {
    return false;
  }

  return Object.entries(data).every(([key, value]) => !!value);
};

export const useUserAuthentication = () => {
  const mutationResult = useAuthenticateMutation();
  const { data: userData } = mutationResult;
  const { writeTokens } = useRequestGateway();

  useEffect(() => {
    if (checkUserData(userData)) {
      writeTokens({
        accessToken: userData.accessToken,
        accessTokenExpiration: userData.accessTokenExpiration,
        refreshToken: userData.refreshToken,
        refreshTokenExpiration: userData.refreshTokenExpiration,
      });
    }
  }, [writeTokens, userData]);

  return mutationResult;
};
